import { render, staticRenderFns } from "./AlternativeContentForm.vue?vue&type=template&id=389cd38b&scoped=true&"
import script from "./AlternativeContentForm.vue?vue&type=script&lang=js&"
export * from "./AlternativeContentForm.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeContentForm.vue?vue&type=style&index=0&id=389cd38b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cd38b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VExpandTransition,VIcon,VSwitch,VTextField})
